import './index.css';
import './customize.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import App from './App';
import { client } from './services';
import reportWebVitals from './reportWebVitals';
import { theme } from './themes/Theme';

import { CacheProvider } from '@emotion/react';
import createEmotionCache from './createEmotionCache';

const emotionCache = createEmotionCache();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <CacheProvider value={emotionCache}>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </ApolloProvider>
  </CacheProvider>
);

reportWebVitals();
